"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateKochavaAttributionEventQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.CreateKochavaAttributionEventQuerySchema = (0, core_1.StrictObject)({
    key: typebox_1.Type.Optional(ruby_1.AttributionSecretKeySchema),
    name: ruby_1.AttributionEventNameSchema,
    timestamp: core_1.TimestampSchema,
    campaignRef: ruby_1.PlatformCampaignRefSchema,
    revenue: typebox_1.Type.Optional(core_1.MoneySchema),
    currency: typebox_1.Type.Optional(core_1.CurrencySchema),
    aidRef: typebox_1.Type.Optional(ruby_1.PlatformAidRefSchema),
    adGroupRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    installedAt: typebox_1.Type.Optional(core_1.TimestampSchema),
    clickedAt: typebox_1.Type.Optional(core_1.TimestampSchema),
    keyword: typebox_1.Type.Optional(ruby_1.AttributionEventKeywordSchema),
    deviceRef: typebox_1.Type.Optional(ruby_1.PlatformDeviceRefSchema),
});
